module.exports = __webpack_public_path__ + "img/home_lijichadan.c2999d7.png";